<template>
  <v-list-item-content>
    <v-list-item-title class="d-flex align-center gap-2">
      <eva-big-icon
        :icon="instruction.icon"
        :size="dense ? 24 : 30"
        color="blue"
      />
      {{ instruction.label }}
    </v-list-item-title>
  </v-list-item-content>
</template>

<script>
import EvaBigIcon from "@/components/shared/eva-big-icon.vue"

export default {
  name: "QuizzesInstructionItem",
  components: {
    EvaBigIcon,
  },
  props: {
    instruction: {
      type: Object,
      required: true,
      validator: (value) => {
        return value.icon && value.label
      },
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
